/**
 * Genera URL wa.me con mensaje pre-cargado para compartir un ticket.
 * No requiere teléfono: el usuario escoge el contacto en WhatsApp.
 */
export function buildWhatsappTicketUrl(ticket, { validationUrl, operatorName, lotteryMap = {}, sorteoMap = {} } = {}) {
  if (!ticket) return "";
  const lines = [];
  lines.push("*Ticket CONNECT*");
  if (operatorName) lines.push(operatorName);
  lines.push("");
  lines.push(`Serial: *${ticket.code}*`);
  // Solo la divisa de emisión (cero conversión dual).
  const cur = ticket.currency || "BS";
  if (cur === "COP") lines.push(`Total: $ ${Number(Math.round(ticket.total_cop || 0)).toLocaleString("es-CO", { maximumFractionDigits: 0 })} COP`);
  else if (cur === "USD") lines.push(`Total: $ ${Number(ticket.total_usd || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD`);
  else lines.push(`Total: Bs ${Number(ticket.total_bs || 0).toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
  const nPlays = (ticket.plays || []).length;
  lines.push(`Jugadas: ${nPlays}`);
  // Adjunta un resumen (hasta 5 jugadas)
  const preview = (ticket.plays || []).slice(0, 5);
  if (preview.length > 0) {
    lines.push("");
    preview.forEach((p) => {
      const lot = lotteryMap[p.lottery_type_id];
      const sor = sorteoMap[p.sorteo_id];
      const hora = sor?.scheduled_at
        ? new Date(sor.scheduled_at).toLocaleTimeString("es-VE", { hour: "2-digit", minute: "2-digit", timeZone: "America/Caracas" })
        : "";
      const parts = [];
      parts.push(`${p.number}`);
      if (lot?.name) parts.push(lot.name);
      if (p.sign) parts.push(p.sign);
      if (hora) parts.push(hora);
      lines.push("• " + parts.join(" · "));
    });
    if (nPlays > preview.length) lines.push(`… y ${nPlays - preview.length} más`);
  }
  if (validationUrl) {
    lines.push("");
    lines.push(`Valida aquí: ${validationUrl}`);
  }
  const text = lines.join("\n");
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}
